var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "newunicommerceproduct"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.success_seen) ? _c('div', {
    staticClass: "alert alert-success hide"
  }, [_vm._v(_vm._s(_vm.success_message))]) : _vm._e(), _vm._v(" "), (_vm.update_seen) ? _c('div', {
    staticClass: "alert alert-success hide"
  }, [_vm._v(_vm._s(_vm.update_message))]) : _vm._e(), _vm._v(" "), (_vm.failure_seen) ? _c('div', {
    staticClass: "alert alert-danger hide"
  }, [_vm._v(_vm._s(_vm.failure_message))]) : _vm._e()])]), _vm._v(" "), _c('b-card', {
    attrs: {
      "title": _vm.$t('editedjson.productSync')
    }
  }, [_c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Go To Unicommerce Product Listing"
    },
    on: {
      "click": _vm.showunicommerceproduct
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px",
      "float": "right",
      "margin-top": "-55px",
      "margin-right": "10px",
      "cursor": "pointer"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container mt-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "17px"
    },
    attrs: {
      "for": "customTextarea"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.importUniwareProduct.labelText')) + " *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "form-control scrollable-textarea",
    attrs: {
      "id": "customTextarea",
      "rows": "10",
      "cols": "5"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, _vm.validateInput],
      "change": _vm.onChangeHandler
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-center mt-2"
  }, [_c('div', {
    staticClass: "productSync-button"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm mx-1 ",
    attrs: {
      "disabled": !_vm.isValid || _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.uploadProductSync($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.importUniwareProduct.productSync')) + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "limit-text"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.importUniwareProduct.limitText')))])]), _vm._v(" "), (_vm.downloadButtonDisplay) ? _c('div', {
    staticClass: "d-flex  ml-2"
  }, [(_vm.downloadCreatedButton) ? _c('button', {
    staticClass: "btn btn-info btn-sm ml-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadCreated($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.importUniwareProduct.downloadCreated')) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.downloadUpdatedButton) ? _c('button', {
    staticClass: "btn btn-warning btn-sm ml-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadUpdated($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.importUniwareProduct.downloadUpdated')) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.downloadFailedButton) ? _c('button', {
    staticClass: "btn btn-danger btn-sm ml-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.downloadFailed($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.importUniwareProduct.downloadFailed')) + "\n                                ")]) : _vm._e()]) : _vm._e()])])])])])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-010cb019", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-010cb019","hasScoped":true}!./src/views/components/uniware/newunicommerceproduct/newunicommerceproduct.component.html
// module id = 1901
// module chunks = 0